// extracted by mini-css-extract-plugin
export default {"audiocall":"Audiocall_audiocall__-qxGO","back-btn":"Audiocall_back-btn__moQiY"};